<div class="custom-letters">
  <div class="custom-letters-heading">
    <h2>custom letters</h2>
    <a (click)="closeCustomLetter()">Close</a>
  </div>

  <div class="documents-block">
    <div class="block box-shadow">
      <div class="block-header">
        <div
          class="name-sort"
          [ngClass]="{ selected: customLettersSort === 'name' }"
          (click)="sortCustomLetters('name')"
        >
          name
        </div>
        <div class="search">
          <input
            aria-label=""
            type="text"
            placeholder="search letters..."
            (keyup)="filterCustomLetters($event.target.value)"
          />
          <img
            class="search-icon"
            [src]="constants.assetsPath + '/img/icons/search-grey.svg'"
          />
        </div>
        <div
          class="decision-sort"
          [ngClass]="{ selected: customLettersSort === 'decision' }"
          (click)="sortCustomLetters('decision')"
        >
          decision
        </div>
      </div>
      <div class="block-content">
        <div
          class="letter"
          #letterTrigger
          #letterPopover="ngbPopover"
          *ngFor="let letter of pagedCustomLetters"
          [ngbPopover]="customLetterContent"
          placement="{{ tooltipPlacement }}"
          popoverClass="instructions-popover"
          [popperOptions]="shrinkInstructionsPopoverGap"
          triggers="mouseenter:mouseleave"
          closeDelay="350"
          (shown)="onInstructionsPopoverShown(letterPopover, letterTrigger)"
          (hidden)="onInstructionsPopoverHidden(letterPopover)"
          (click)="selectCustomLetter(letter)"
          [ngClass]="{
            selected: letter.selected,
            disabled: !letter.selected && existLetterSelected()
          }"
          [attr.data-id]="'custom-letter-' + letter.id"
        >
          <div class="title">
            {{ letter.id }} {{ letter.name }}
            <span class="text-selected" *ngIf="letter.selected">selected</span>
          </div>
          <div
            class="decision"
            [ngClass]="{
              green: letter.decisionId === 1 || letter.decisionId === 0,
              red: letter.decisionId === 2,
              blue: letter.decisionId === 3
            }"
          >
            {{ letter.decisionName }}
          </div>
          <ng-template #customLetterContent>
            <div [innerHTML]="letter.instructions | linkify"></div>
          </ng-template>
        </div>
        <div class="letter disabled" *ngIf="pagedCustomLetters.length === 0">
          <div class="title">Ooops, there are no custom letters!</div>
        </div>
      </div>
      <div class="block-footer">
        <div
          class="page-number"
          *ngFor="let pageIndex of pagesList"
          [ngClass]="{ selected: pageIndex === selectedPage }"
          (click)="changePage(pageIndex)"
        >
          {{ pageIndex }}
        </div>
      </div>
    </div>
  </div>
</div>
